import { useEffect, useCallback } from "react"

const QUERY_PARAM = "path"

// Read the ref-db sub-path stored in the parent URL search params
const getPathFromUrl = () => {
  const params = new URLSearchParams(window.location.search)
  return params.get(QUERY_PARAM) || ""
}

// Update the parent URL without triggering a navigation
const setPathInUrl = (subPath) => {
  const url = new URL(window.location)
  if (subPath) {
    url.searchParams.set(QUERY_PARAM, subPath)
  } else {
    url.searchParams.delete(QUERY_PARAM)
  }
  window.history.replaceState(null, "", url)
}

// Extract the sub-path after "/external/" from the iframe pathname
const extractExternalSubPath = (pathname) => {
  const match = pathname.match(/\/external\/(.+)/)
  return match ? match[1] : ""
}

/**
 * Syncs the ref-db iframe navigation state with the parent URL.
 *
 * Listens for postMessage events from the iframe (type "refDbPath")
 * and persists the current sub-path as a query parameter (?path=…).
 * Returns the cached path so the iframe can be restored on re-mount.
 */
const useRefDbPathCache = (refDbOrigin) => {
  const handleMessage = useCallback(
    (event) => {
      if (event.origin !== refDbOrigin) return

      const { type, path } = event.data || {}
      if (type === "refDbPath" && typeof path === "string") {
        setPathInUrl(extractExternalSubPath(path))
      }
    },
    [refDbOrigin]
  )

  useEffect(() => {
    window.addEventListener("message", handleMessage)
    return () => window.removeEventListener("message", handleMessage)
  }, [handleMessage])

  return getPathFromUrl()
}

export { useRefDbPathCache }
